/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 19/10/22
 */

import { useAssignment } from '@/components/contexts/AssignmentContext/useAssignment';
import ExportWorkplan, { ExportWorkplanRef } from '@/components/export/ExportWorkplan';
import { Assignment } from '@/wpt-lib/interfaces/Assignment';
import { Workplan } from '@/wpt-lib/interfaces/Workplan';
import { DownloadIcon } from '@chakra-ui/icons';
import { Button, Text } from '@chakra-ui/react';
import { useCallback, useRef } from 'react';
import React from 'react';

interface DownloadWorkplanButtonProps {
    workplan: Workplan;
    assignment?: Assignment;
    version?: number;
}

const DownloadWorkplanButton = ({ workplan, version }: DownloadWorkplanButtonProps) => {
    const { currentAssignment } = useAssignment();
    const exportRef = useRef<ExportWorkplanRef | null>(null);

    const downloadWorkplan = useCallback(() => {
        if (currentAssignment) {
            exportRef.current?.export(workplan, version ?? workplan.currentVersion.version, currentAssignment);
        }
    }, [workplan, currentAssignment, version]);

    return (
        <Button
            leftIcon={<DownloadIcon />}
            variant="outline"
            whiteSpace={'normal'}
            size="md"
            onClick={downloadWorkplan}
            rounded="none"
            ml={0}
        >
            <Text>Download Workplan</Text>
            <ExportWorkplan ref={exportRef} />
        </Button>
    );
};

export default DownloadWorkplanButton;
